import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';
import isEqual from 'lodash/isEqual';

import { LabelContainer } from '@motorway/motorway-component-library';

import CheckboxGroup from 'Components/shared/CheckBoxGroup/CheckboxGroup';
import ExpandableFilter from 'Components/shared/ExpandableFilter/ExpandableFilter';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';

import useFilterView from '../useFilterView';

import styles from '../Filters.module.scss';

T.setTexts(require('Components/texts.json'));

const CheckboxGroupFilterView = ({ badge, checked, columns, defaultExpanded, id, name, onClick, options, title }) => {
	const {
		maxWidth: { breakpointMobile: isMobile },
	} = useBreakpoint();
	const { isExpandableFilter } = useFilterView();
	const Badge = badge ?? (() => null);
	const props = {
		checked,
		columns,
		name,
		options,
	};

	return (
		<>
			{isExpandableFilter ? (
				<ExpandableFilter
					badge={Badge}
					classNames={{
						content: styles.expandableCheckBoxGroup,
						expanded: styles.expandedCheckBoxGroup,
					}}
					defaultExpanded={defaultExpanded}
					id={id}
					isDirty={!isEqual(checked, [])}
					title={title}
				>
					{(isOpen) => (
						<CheckboxGroup {...props} columns={columns?.desktop ?? 2} onClick={onClick} tabIndex={isOpen ? 0 : -1} />
					)}
				</ExpandableFilter>
			) : (
				<div className={cx('mw-mt-3 mw-mb-3', { 'mw-mb-2': isMobile })}>
					<LabelContainer
						className="mw-mt-3 mw-mb-1"
						label={title}
						labelAfter={<Badge />}
						labelAfterClassName={cx(styles.labelAfterContainer)}
					/>
					<CheckboxGroup {...props} columns={columns?.mobile ?? 3} onClick={onClick} />
				</div>
			)}
		</>
	);
};

export const CheckBoxGroupProps = {
	checked: PropTypes.arrayOf(PropTypes.string).isRequired,
	columns: PropTypes.shape({
		desktop: PropTypes.number,
		mobile: PropTypes.number,
	}),
	defaultExpanded: PropTypes.bool,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string,
		}),
	).isRequired,
	title: PropTypes.node.isRequired,
};

CheckboxGroupFilterView.propTypes = {
	...CheckBoxGroupProps,
};

export default CheckboxGroupFilterView;
